import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import { ScholarshipCategoryDto } from '@cradua/data';

@Component({
  selector: 'mrsoftapps-scholarship-category-view',
  templateUrl: './scholarship-category-view.component.html',
  styleUrls: ['./scholarship-category-view.component.css'],
})
export class ScholarshipCategoryViewComponent implements OnInit {
  @Input() scholarshipCategories: ScholarshipCategoryDto[];
  scholarshipCategoryForm: FormGroup;
  control = new FormControl();
  @Output() changeEmit = new EventEmitter<ScholarshipCategoryDto>();
  @Output() deleteEvent = new EventEmitter<any>();
  @Output() printEvent = new EventEmitter<any>();

  SubscriberId = '5ca0c7a7ef1d2e5760762ebd';
  filteredDelete: Array<any> = [];
  loading = true;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.scholarshipCategoryForm = this.fb.group({
      ScholarshipCategories: this.fb.array([]),
    });
    this.setScholarshipCategory();
  }

  clickme(value) {
    console.log('click ', value);
  }

  // method to display scholarshipCategories
  setScholarshipCategory() {
    const control = this.scholarshipCategoryForm.controls
      .ScholarshipCategories as FormArray;
    this.scholarshipCategories.forEach((e) => {
      control.push(
        this.fb.group({
          ScholarshipCategoryName: e.ScholarshipCategoryName,
          id: e.id,
        })
      );
    });
  }

  // method to add ScholarshipCategory
  addScholarshipCategory() {
    const control = this.scholarshipCategoryForm.controls
      .ScholarshipCategories as FormArray;
    control.insert(
      0,
      this.fb.group({
        ScholarshipCategoryName: ['', Validators.required],
        id: null,
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete scholarshipCategory from arrary list
  deleteScholarshipCategory(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.scholarshipCategoryForm.controls
          .ScholarshipCategories as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.scholarshipCategories.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.scholarshipCategories[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'scholarshipCategory';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('scholarshipCategory');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
